import React from "react";
import { Typography } from "antd";
import { useIntl } from "react-intl";
import moment from "moment";
import { getProffesionalName } from "../../../components/util/helpers";
const { Title, Text } = Typography;

const CurrentVisit = (props) => {
  const { record } = props;
  const intl = useIntl();

  return (
    <div
      className="borderedSection"
      style={{
        width: "100%",
        // width: "fit-content",
        padding: "0 10px",
        border: "1px dashed",
        paddingBottom: "5px",
      }}
    >
      <Title level={4}>
        {intl.formatMessage({
          id: "app.house_visits.table.current_visit",
        })}
      </Title>
      <div
        style={{
          width: "max-content",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Text>
          <span style={{ fontWeight: "bold" }}>{`${intl.formatMessage({
            id: "app.house_visits.table.plannedDate",
          })}: `}</span>
          {record.date && `${record.date && moment(record.date).format("L")}`}
        </Text>
        <Text>
          <span style={{ fontWeight: "bold" }}>{`${intl.formatMessage({
            id: "app.house_visits.table.plannedEmployee",
          })}: `}</span>
          {record.employee && getProffesionalName(record.employee, intl)}
        </Text>
        <Text>
          <span style={{ fontWeight: "bold" }}>{`${intl.formatMessage({
            id: "app.house_visits.table.care_giver_was_presented",
          })}: `}</span>
          {record.care_giver_was_presented
            ? intl.formatMessage({
                id: "app.forms.yes",
              })
            : record.care_giver_was_presented === false &&
              intl.formatMessage({
                id: "app.forms.no",
              })}
        </Text>
      </div>
    </div>
  );
};

export default CurrentVisit;
